import React from 'react'
import { AnimationOnScroll } from 'react-animation-on-scroll'
import { Row, Col, Image } from 'react-bootstrap'
import { logo3d } from '../../assets'

export default function ServiceSection() {
    return (
        <Row className='service-section mx-0'>
            <Col md={6} className='d-flex flex-column align-items-center justify-content-center'>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <h3 style={{ fontSize: '3em', fontWeight: '800', textAlign: 'start' }}>Customer friendly<br />service</h3>
                </AnimationOnScroll>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp">
                    <p align='left' style={{ fontSize: '1.5em', fontWeight: '800', }}>Since our inception in 2001, Kaptain<br />
                        Plywood is committed to delivering<br />
                        high quality plywood to our <br />
                        customers. We pride ourselves in our<br />
                        quality assurance, product<br />
                        accountability and unparalleled<br />
                        customer-service</p>
                </AnimationOnScroll>
            </Col>
            <Col md={6} className='position-relative'>
                <AnimationOnScroll duration={2} animateIn="animate__slideInUp" className='service-section-card position-absolute'>
                    <Image src={logo3d} />
                </AnimationOnScroll>
            </Col>
        </Row>
    )
}
